import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function EmptyCard(props) {
    var ref = props || {}, _title = ref.title, title = _title === void 0 ? '' : _title, righter = ref.righter, titleExtra = ref.titleExtra, children = ref.children, _titleClassName = ref.titleClassName, titleClassName = _titleClassName === void 0 ? '' : _titleClassName, _className = ref.className, className = _className === void 0 ? '' : _className, style = ref.style, hideTitle = ref.hideTitle;
    return(/*#__PURE__*/ _jsxs("div", {
        className: "mb-[24px] ".concat(className),
        style: style,
        children: [
            !hideTitle && /*#__PURE__*/ _jsxs("div", {
                className: "relative mb-[16px]",
                children: [
                    righter && /*#__PURE__*/ _jsx("div", {
                        className: "absolute bottom-[-5px] right-[10px]",
                        children: righter
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "text-base text-[18px] font-inter-semibold flex items-center",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "inline-block align-middle h-[24px] ".concat(titleClassName),
                                children: title
                            }),
                            titleExtra && /*#__PURE__*/ _jsx("div", {
                                className: "inline-block align-middle",
                                children: titleExtra
                            })
                        ]
                    })
                ]
            }),
            children
        ]
    }));
}
export var CardContainer = function(props) {
    var children = props.children, className = props.className;
    return(/*#__PURE__*/ _jsx("div", {
        className: "bg-white rounded-[6px] w-[100%] ".concat(className),
        children: children
    }));
};
export default EmptyCard;
